import { Input, Label } from '@immo/ui-kit';

type ComingSoonFieldProps = {
  readonly id: string;
  readonly label: string;
  readonly placeholder: string;
  readonly comingSoonLabel: string;
  readonly multiline?: boolean;
};

export function ComingSoonField({ id, label, placeholder, comingSoonLabel, multiline = false }: ComingSoonFieldProps) {
  return (
    <div className="space-y-1">
      <div className="flex items-center gap-2">
        <Label htmlFor={id}>{label}</Label>
        <span
          className="inline-flex items-center rounded-full bg-neutral-100 px-2 py-0.5 text-xs font-medium text-text-tertiary"
          title={comingSoonLabel}
        >
          {comingSoonLabel}
        </span>
      </div>
      {multiline ? (
        <textarea
          id={id}
          value=""
          placeholder={placeholder}
          onChange={() => undefined}
          disabled
          rows={3}
          title={comingSoonLabel}
          className="flex w-full resize-none rounded-md border border-border bg-surface px-3 py-2 text-base font-sans text-text-primary placeholder:text-text-placeholder disabled:cursor-not-allowed disabled:opacity-60"
        />
      ) : (
        <Input
          id={id}
          value=""
          placeholder={placeholder}
          onChange={() => undefined}
          disabled
          invalid={false}
          aria-describedby={undefined}
          title={comingSoonLabel}
        />
      )}
    </div>
  );
}
